module.exports = __webpack_public_path__ + "img/soy_beans.36ad68ad.svg";